import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { Vortex } from 'react-loader-spinner'
import Pagination from '../../CommonUI/Pagination/Pagination';
import FandOOpt from "./FandOOpt";

function MostActiveCallOPT() {
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([])
    const [loadingshow, setloadingshow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    let getOptionSymbol, PageSize = 7;
    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "HighLowOpenIntrest";
        fetch(`${getUrl}/Mw/-/opt/-/C/-/-/-/-`)
            .then((response) => response.json())
            .then((data) => {
                setData(data.data);
                setloadingshow(false);
                console.log(data.data, "highlow")
                
                // setloadingshow(false)
            })
            .catch((error) => {
                //console.log("not found the api");
            });

    }, [])

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Most Active Call</li>
                </ul>
            </div>
            <div className='market-inner-common market-mf-main'>
                <div className='toplose-header'>
                    <h2><span>Most Active Call</span></h2>
                </div>
                <FandOOpt optionValue="Most Active Call" optionDrop="Options" />
                <Container>
                    <div className=''>
                        <div className='mf-table table-responsive gainer-table'>
                            <div className='newhigh-table table-responsive'>
                                <table className='table'>

                                    <thead>
                                        <tr>
                                            <th className='text-left'>Instrument Type</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-right'>Symbol</th>
                                            <th className='text-right'>Option Type</th>
                                            <th className='text-right'>Strike Price(&#8377;)</th>
                                            <th className='text-right'>LTP (&#8377;)</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ InstName, ExpDate, Symbol, OptType, StrikePrice, LTP }) => (
                                                <tr>
                                                    <td className='text-left'>{InstName}</td>
                                                    <td className='text-right'>{ExpDate.split('T')[0]}</td>
                                                    <td className='text-center'>{Symbol}</td>
                                                    <td className='text-center'>{OptType}</td>
                                                    <td className='text-right'>{StrikePrice != null ? StrikePrice.toFixed(2) : 0}</td>
                                                    <td className='text-right'>{LTP != null ? LTP.toFixed(2) : 0}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>

                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </div>
                        {(data != null && data != []) ?
                            <Pagination
                                className="pagination-bar_peer"
                                currentPage={currentPage}
                                totalCount={(data.length != null) ? data.length : 0}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            /> : <p className="errorPeer"> No Data Found !!! </p>}
                    </div>
                </Container>
            </div>
        </>
    )
}

export default MostActiveCallOPT